<template>
  <Drawer
    :id="drawerId"
    title="Validate Costs & Address"
    :loading="loading"
  >
    <v-card flat>
      <v-simple-table>
        <template #default>
          <tbody>
            <tr>
              <td>Real-time Product Cost:</td>
              <td>{{ job_validation.productCost | currency }}</td>
            </tr>
            <tr>
              <td>Customer Paid Product Price</td>
              <td>{{ job.basePrice | currency }}</td>
            </tr>
            <tr>
              <td>Customer Paid Turnaround</td>
              <td>{{ job.turnaroundPrice | currency }}</td>
            </tr>
            <tr>
              <td>Customer Paid Shipping</td>
              <td>
                {{ job.shippingPrice | currency }} - {{ job.shippingServiceName }} ({{
                  job.shippingServiceCode
                }})
              </td>
            </tr>
            <tr v-if="job.bypassAddressValidation">
              <td>
                <span class="font-weight-bold"> * Address Validation Bypassed * </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-text>
        <v-row>
          <v-col
            v-for="(item, i) in job_validation.shippingOptions"
            :key="i"
            cols="12"
          >
            <v-card
              :class="{
                'mcsprimary white--text':
                  item.externalShippingCode === job.shippingServiceCode &&
                  item.externalShippingMethod === job.shippingServiceName
              }"
            >
              <div class="pa-4">
                <v-row>
                  <v-col>
                    <div>
                      <span class="font-weight-bold mr-1">Facility:</span>
                      {{ item.facilityCode }}
                    </div>
                    <div>
                      <span class="font-weight-bold m1-1">Service:</span>
                      {{ item.externalShippingMethod }} ({{ item.externalShippingCode }})
                    </div>
                    <div>
                      <span class="font-weight-bold m1-1">Days:</span>
                      {{ item.days }}
                    </div>
                    <div>
                      <span class="font-weight-bold m1-1">Price:</span>
                      {{ item.price | currency }}
                    </div>
                  </v-col>
                  <v-spacer class="limited-spacer" />
                  <v-col
                    cols="auto"
                    class="my-auto"
                  >
                    <v-btn @click="selectDelivery(item)"> Select </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
          <template v-if="!job.bypassAddressValidation">
            <v-col
              v-for="(item, i) in job_validation.addressOptions"
              :key="i"
              cols="12"
            >
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <div>
                        {{ item.line1 }}
                      </div>
                      <div v-if="item.line2">
                        {{ item.line2 }}
                      </div>
                      <div>
                        {{ item.city }} {{ item.state }}, {{ item.postalCode }}
                        {{ item.countryCode }}
                      </div>
                    </v-col>
                    <v-spacer class="limited-spacer" />
                    <v-col
                      cols="auto"
                      class="my-auto"
                    >
                      <v-btn @click="selectAddress(item)"> Select </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col class="my-auto"> Unable to validate? </v-col>
                    <v-spacer class="limited-spacer" />
                    <v-col
                      cols="auto"
                      class="my-auto"
                    >
                      <v-btn @click="bypass"> Bypass Validation </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </Drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import Drawer from '@/components/layout/Drawer';
import enums from '../../../helpers/enums';
export default {
  name: 'PrintJobValidate',
  components: { Drawer },
  data() {
    return {
      valid: false,
      savingId: null,
      job: {},
      loading: false,
      drawerId: enums.DRAWERS.PRINT_JOB_VALIDATE_COSTS
    };
  },
  computed: {
    countriesToShow() {
      return this.countries.filter((x) => x.isPrintable);
    },
    drawerOpenedAt() {
      return this.$store.state.drawers.lastOpenedAt;
    },
    ...mapGetters({
      job_validation: 'orders/job_validation',
      initialData: 'drawers/data'
    })
  },
  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.job = cloneDeep(this.initialData(this.drawerId).job);
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('orders/validateShippingAndAddress', this.job.jobId)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectAddress(address) {
      this.savingId = address.id;
      this.$store
        .dispatch('orders/validateAddress', {
          orderId: this.job.orderId,
          jobId: this.job.jobId,
          address: address
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingId = null;
        });
    },
    selectDelivery(delivery) {
      this.savingId = delivery.id;
      this.$store
        .dispatch('orders/validateDelivery', {
          orderId: this.job.orderId,
          jobId: this.job.jobId,
          delivery: delivery
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingId = null;
        });
    },
    bypass() {
      this.$store
        .dispatch('orders/bypassAddressValidation', {
          orderId: this.job.orderId,
          jobId: this.job.jobId
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        });
    }
  }
};
</script>
